import points from '../Assets/icons/threepoints.svg'
import arrowUp from '../Assets/icons/arrowUp.svg'
import arrowDown from '../Assets/icons/arrowDown.svg'
import walletIcon from '../Assets/icons/walletIcon.svg'


const EntradasComponent = ({userData }) => {


    if (userData == null) {
        return <div className='w-full h-screen bg-[#171717]'>
            loading...
        </div>
    }
    return (
        <div>
            <div className="w-full mt-4 gap-4 grid md:grid-cols-3">
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Recebido</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.lucro}</p>
                        <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#14CA74] hidden bg-[#14CA742D]'>
                            28.84%
                        </div>
                    </div>
                </div>

                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Ticket médio</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>{userData.ticketMedio}</p>
                        <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#14CA74] hidden bg-[#14CA742D]'>
                            28.84%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Quantidade de transações confirmadas</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>{userData.quantidadeTransaction}</p>
                        <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#14CA74] hidden bg-[#14CA742D]'>
                            28.84%
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EntradasComponent